import { AttendeeFixedCostState } from './types';

export const state = (): AttendeeFixedCostState => initialState();

export const initialState = (): AttendeeFixedCostState => ({
  attendeeFixedCosts: [],
});
